export const getDeviceType = () => {
  const ua = navigator.userAgent;
  const {platform} = window.navigator;

  if (/android/i.test(ua)) {
    return 'Android';
  }

  if (
    (/iPad|iPhone|iPod/.test(ua) && !(window as any).MSStream) ||
    // For new IPads with M1 chip and IPadOS platform returns "MacIntel"
    (platform === 'MacIntel' &&
      'maxTouchPoints' in navigator &&
      navigator.maxTouchPoints > 2)
  ) {
    return 'iOS';
  }

  if (/Windows Phone/i.test(ua)) {
    return 'Windows Phone';
  }

  if (/Macintosh|MacIntel|MacPPC|Mac68K/.test(ua)) {
    return 'Mac';
  }

  if (/Win32|Win64|Windows|WinCE/.test(ua)) {
    return 'Windows';
  }

  if (/Linux/i.test(ua)) {
    return 'Linux';
  }

  return 'Unknown';
};
